import { Link, useParams } from 'react-router-dom';
import { MenuExperience } from '@restaurant-menu-saas/menu-renderer';
import { api } from '../../api/client.js';
import { useApiQuery } from '../../api/useApiQuery.js';

// Read-only, same as the tenant admin's own preview (spec §12: reuse the
// same rendering components rather than a second implementation) — Super
// Admin can look at what a restaurant has built for support/oversight,
// never edit it.
export function TenantMenuPreviewPage() {
  const { tenantId, menuId } = useParams();
  const { data: tree, loading, error } = useApiQuery(
    () => api.get(`/api/super-admin/tenants/${tenantId}/menus/${menuId}/preview`),
    [tenantId, menuId],
  );

  return (
    <div className="menu-preview-page">
      <div className="preview-toolbar">
        <Link className="back-link" to={`/super-admin/tenants/${tenantId}`}>← Back to tenant</Link>
        <span className="badge badge-muted">Read-only</span>
      </div>
      {loading && <span className="spinner" aria-label="Loading" style={{ margin: 20 }} />}
      {error && (
        <div className="alert alert-error" style={{ margin: 20 }}>
          {error.message}
        </div>
      )}
      {tree && <div className="menu-preview-frame"><MenuExperience menuData={tree} /></div>}
    </div>
  );
}
